"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBeginTranscriptUploadResult = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateBeginTranscriptUploadResult = (0, validation_1.properties)({
    fields: (0, validation_1.dictionary)((0, validation_1.any)()),
    url: (0, validation_1.text)(),
    id: (0, validation_1.text)(),
});
//# sourceMappingURL=BeginTranscriptUploadResult.js.map